import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import {Formatter} from "@/core/services/formatter.service";
import {getPhoneRuleObj} from "@/plugins/vee-validate";
import {uuid} from "vue-uuid";
import {store} from "@/plugins/vuex";


export default class TemporaryItemModel extends BaseModel {
  uuid = null;
  rep_user_uuid = null;
  expert_user_uuid = null;
  lot_handling_charge = null;
  receive_date = Formatter.getNowAsDate();
  dynamic_fields = {};
  department_uuid = null;
  category_uuid = null;
  item_location_uuid = null;
  customer_uuid = null;
  low = null;
  high = null;
  start_price = null;
  reserve = null;
  tax_status_uuid = null;
  net_reserve = false;
  insurance = null;
  department = {};
  category = null;
  specialists_uuids = [];
  specialists = [];
  images = [];
  progress = 'pending';
  potential = 'low';

  collection_info_enabled = false;
  collection_info_address_1 = null;
  collection_info_address_2 = null;
  collection_info_state = null;
  collection_info_city = null;
  collection_info_zip_code = null;
  collection_info_phone = null;
  collection_info_first_name = null;
  collection_info_last_name = null;
  collection_info_email = null;
  collection_info_notes = null;
  enable_customer_edit = false;
  reserve_type = null;

  rules = {
    quantity: 'required|min_value:1',
    receipt_uuid: 'required',
    item_location_uuid: 'required',
    insurance: 'max_value:100|min_value:0',
    minimum_commission: 'max_value:100|min_value:0',
    department_uuid: 'required',
    category_uuid: 'required',
    customer_uuid: 'required',
    progress: 'required',
    potential: 'required',

    collection_info_email: 'email|max:73',
    collection_info_phone: getPhoneRuleObj(),
    collection_info_notes: `max:150`,
  };

  attributeHints = {
    tax_status_uuid: i18n.t('Vendor tax status will be assigned if left blank'),
    title: i18n.t('For formatting, please highlight the text'),
    description: i18n.t('For formatting, please highlight the text'),
  };

  attributeLabels = {
    uuid: i18n.t('UUID'),
    quantity: i18n.t('Quantity'),
    receipt_uuid: i18n.t('Receipt'),
    rep_user_uuid: i18n.t('Representative User'),
    expert_user_uuid: i18n.t('Expert User'),
    lot_handling_charge: i18n.t('Lot Handling Charge'),
    receive_date: i18n.t('Receive Date'),
    description: i18n.t('Description'),
    department_uuid: i18n.t('Department'),
    category_uuid: i18n.t('Category'),
    specialists_uuids: i18n.t('Specialists'),
    customer_uuid: i18n.t('Customer'),
    low: i18n.t('Low'),
    high: i18n.t('High'),
    start_price: i18n.t('Start Price'),
    reserve: i18n.t('Reserve'),
    net_reserve: i18n.t('NET Reserve'),
    item_location_uuid: i18n.t('Item Location'),
    title: i18n.t('Title'),
    tax_status_uuid: i18n.t('Tax Status'),
    minimum_commission: i18n.t('Minimum Commission'),
    images: i18n.t('Images'),
    progress: i18n.t('Progress'),
    potential: i18n.t('Potential'),

    collection_info_enabled: i18n.t('Collection Information'),
    collection_info_address_1: i18n.t('Address 1'),
    collection_info_address_2: i18n.t('Address 2'),
    collection_info_city: i18n.t('City'),
    collection_info_state: i18n.t('State/County'),
    collection_info_zip_code: i18n.t('Zip/Postcode'),
    collection_info_phone: i18n.t('Phone'),
    collection_info_email: i18n.t('Email'),
    collection_info_first_name: i18n.t('Contact First Name'),
    collection_info_last_name: i18n.t('Contact Last Name'),
    collection_info_notes: i18n.t('Collection Notes'),
    enable_customer_edit: i18n.t('Enable Customer Edit'),
    reserve_type: i18n.t('Reserve Type')
  };

  toJSON() {
    let data = super.toJSON();
    data.images = data.images.map(i => {
      if (i.position && i.image_uuid)
        return {base64: i.base64, position: i.position, image_uuid: i.image_uuid}
      return {base64: i.base64}
    })
    return data;
  }

  constructor(data = {}, runInit = true) {
    super();
    Object.assign(this, {...data});
    if (!this.images) {
      this.images = [];
    } else {
      this.images.forEach((image) => {
        image.to_be_deleted = false;
        if (!image.uuid) {
          image.uuid = uuid.v4();
        }
      });
    }
    if (runInit) {
      this.initDynamicFields(this, this.category ? this.category.dynamic_fields_template : null);
    }
  }
}
